module.exports = __webpack_public_path__ + "img/refer3.png";